/**
 * <product-format-switcher>
 *
 * Renders the Fine art print / Canvas style buttons. Each format is a separate,
 * fully independent product, so selecting a format navigates to that product's
 * page (which carries its own gallery + thumbnails). The buttons reuse the
 * variant picker's radio markup purely for styling; this element turns a
 * selection change into a navigation.
 */
class ProductFormatSwitcher extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
  }

  #onChange = (event) => {
    const input = event.target.closest('input[type="radio"]');
    if (!input) return;

    // The current product's radio carries `data-current` — ignore it.
    if (input.hasAttribute('data-current')) return;

    const url = input.dataset.url;
    if (url) {
      window.location.href = url;
    }
  };
}

if (!customElements.get('product-format-switcher')) {
  customElements.define('product-format-switcher', ProductFormatSwitcher);
}
